import type { CheckStep } from '../types/checks'

export const checks: CheckStep[] = [
  {
    id: 'buscar',
    number: 1,
    title: 'Buscar mi iPhone',
    path: ['Configuración', 'Tu nombre', 'Buscar'],
    toggles: ['Buscar mi iPhone', 'Red Buscar', 'Enviar última ubicación'],
    noteLabel: '¿Por qué?',
    note: 'Si alguna vez perdés el teléfono, estas tres opciones pueden marcar la diferencia para recuperarlo.',
  },
  {
    id: 'faceid',
    number: 2,
    title: 'Face ID',
    path: ['Configuración', 'Face ID y código'],
    toggles: ['Desbloqueo del iPhone', 'App Store', 'Contraseñas', 'Wallet (si la usás)'],
    noteLabel: '¿Por qué?',
    note: 'Muchísima gente configura Face ID una sola vez y nunca vuelve a revisar qué protege realmente.',
  },
  {
    id: 'ubicacion',
    number: 3,
    title: 'Ubicación',
    path: ['Configuración', 'Privacidad y seguridad', 'Localización'],
    question: 'Revisá qué aplicaciones tienen acceso permanente a tu ubicación.',
    noteLabel: 'Consejo',
    note: 'Si una aplicación no necesita saber dónde estás todo el tiempo… no le des permiso permanente.',
  },
  {
    id: 'notificaciones',
    number: 4,
    title: 'Notificaciones',
    path: ['Configuración', 'Notificaciones'],
    question: '¿Realmente necesito que TODAS las aplicaciones me interrumpan?',
    noteLabel: 'Por qué importa',
    note: 'Desactivar notificaciones innecesarias hace que el iPhone sea mucho más cómodo de usar.',
  },
  {
    id: 'actualizaciones',
    number: 5,
    title: 'Actualizaciones',
    path: ['Configuración', 'General', 'Actualización de software'],
    toggles: ['Actualizaciones automáticas'],
    question: 'Si tenés una actualización pendiente… no la ignores durante meses.',
    noteLabel: 'Por qué importa',
    note: 'Así tu iPhone se mantiene protegido y actualizado.',
  },
]

export const remainingTopics: string[] = [
  'Batería',
  'Cámara',
  'Privacidad',
  'iCloud',
  'Almacenamiento',
  'WhatsApp',
  'Seguridad',
  'Llamadas',
  'Fotos',
]
